import { Modal } from "antd";
import styled from "styled-components";

import { Text } from "@/components/Typography";

export const ModalStyled = styled(Modal)`
    .ant-modal-content {
        background: ${props => props.theme.features.firstBillingModal.bgColor};

        .ant-modal-footer {
            background: transparent;
        }
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 240px 0 24px;
`;

export const LummyLogo = styled.figure`
    position: absolute;
    top: 40px;
    left: 50px;
    margin: 0;
`;

export const Description = styled(Text)`
    white-space: break-spaces;
`;
